import { baseURL } from '..';
import { IMaterial } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { IGetMaterialPreviewResponse } from './iApiResponse';

const materialProvider = () => {

    const getMaterialPreviewAsync = async (pageNumber?: number, pageSize?: number, filter?: string, withTests?: boolean): Promise<IResponse<IPaginatedResponse<IGetMaterialPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Material/GetMaterialPreviews', paginationQuery(pageNumber, pageSize, filter, withTests)), createHeaders());

    const getMaterialByIdAsync = async (id: number): Promise<IResponse<IMaterial>> => httpClient.getAsync(createRequest(baseURL, '/Material/GetMaterial', `?id=${id}`), createHeaders());

    const getMaterialByCategoryAsync = async (flag: number): Promise<IResponse<IMaterial[]>> =>
        httpClient.getAsync(createRequest(baseURL, '/Material/GetMaterialsByCategory', `?flagValue=${flag}`), createHeaders());

    const updateMaterialAsync = async (payload: IMaterial): Promise<IResponse<IMaterial>> =>
        httpClient.putAsync(createRequest(baseURL, '/Material/UpdateMaterial', undefined, payload), createHeaders());

    const insertMaterialWithImageAsync = async (payload: FormData): Promise<IResponse<IMaterial>> =>
        httpClient.postAsync(createRequest(baseURL, '/Material/InsertMaterialWithImage', undefined, payload), createHeaders('multipart/form-data'));

    const updateMaterialWithImageAsync = async (payload: FormData): Promise<IResponse<IMaterial>> =>
        httpClient.putAsync(createRequest(baseURL, '/Material/UpdateMaterialWithImage', undefined, payload), createHeaders('multipart/form-data'));

    const getAllMaterialPreviewAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IGetMaterialPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Material/GetAllMaterialPreviews', paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    return { getMaterialPreviewAsync, updateMaterialWithImageAsync, insertMaterialWithImageAsync, getMaterialByIdAsync, getAllMaterialPreviewAsync, getMaterialByCategoryAsync, updateMaterialAsync };
};

export default materialProvider();
